// src/components/LoadingIndicator.jsx
import React from 'react';

/**
 * A mobile-friendly loading indicator component 
 * 
 * @param {Object} props Component props
 * @param {string} props.size Size of the spinner ('small', 'medium', 'large')
 * @param {string} props.color Color of the spinner ('primary', 'secondary', 'white')
 * @param {string} props.label Optional text label to display
 * @param {boolean} props.fullPage Whether this is a full-page loading indicator
 * @param {string} props.className Additional CSS classes
 */
const LoadingIndicator = ({
  size = 'medium',
  color = 'primary',
  label,
  fullPage = false,
  className = ''
}) => {
  // Size classes
  const sizeMap = {
    small: 'h-4 w-4 border-2',
    medium: 'h-8 w-8 border-2',
    large: 'h-12 w-12 border-3'
  };
  
  // Color classes
  const colorMap = {
    primary: 'border-slate-200 border-t-slate-600',
    secondary: 'border-gray-200 border-t-gray-600',
    white: 'border-gray-100/30 border-t-white'
  };
  
  const spinnerClass = `
    inline-block rounded-full animate-spin
    ${sizeMap[size] || sizeMap.medium}
    ${colorMap[color] || colorMap.primary}
    ${className}
  `;
  
  // Full page container
  if (fullPage) {
    return (
      <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white bg-opacity-75">
        <div className={spinnerClass}></div>
        {label && (
          <p className="mt-4 text-sm text-gray-600">{label}</p>
        )}
      </div>
    );
  }
  
  // Regular spinner with optional label
  return (
    <div className="flex flex-col items-center justify-center py-4">
      <div className={spinnerClass}></div>
      {label && (
        <p className="mt-2 text-xs sm:text-sm text-gray-600">{label}</p>
      )}
    </div>
  );
};

export default LoadingIndicator;